// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicOffensesControllerGetByVariableSymbolData } from './PublicOffensesControllerGetByVariableSymbolData.gen';
import type { PublicOffensesControllerGetByVariableSymbolErrors } from './PublicOffensesControllerGetByVariableSymbolErrors.gen';
import type { PublicOffensesControllerGetByVariableSymbolResponses } from './PublicOffensesControllerGetByVariableSymbolResponses.gen';
import type { PublicOffensesControllerImportOffensesData } from './PublicOffensesControllerImportOffensesData.gen';
import type { PublicOffensesControllerImportOffensesErrors } from './PublicOffensesControllerImportOffensesErrors.gen';
import type { PublicOffensesControllerImportOffensesResponses } from './PublicOffensesControllerImportOffensesResponses.gen';
import type { PublicOffensesControllerPayOffenseData } from './PublicOffensesControllerPayOffenseData.gen';
import type { PublicOffensesControllerPayOffenseErrors } from './PublicOffensesControllerPayOffenseErrors.gen';
import type { PublicOffensesControllerPayOffenseResponses } from './PublicOffensesControllerPayOffenseResponses.gen';

export class PublicOffensesController {
    /**
     * Get offenses by variable symbol.
     */
    public static getByVariableSymbol<ThrowOnError extends boolean = false>(options: Options<PublicOffensesControllerGetByVariableSymbolData, ThrowOnError>) {
        return (options.client ?? client).get<PublicOffensesControllerGetByVariableSymbolResponses, PublicOffensesControllerGetByVariableSymbolErrors, ThrowOnError>({ url: '/api/public/offenses/{variableSymbol}', ...options });
    }
    
    /**
     * Pay all offenses by variable symbol.
     */
    public static payOffense<ThrowOnError extends boolean = false>(options: Options<PublicOffensesControllerPayOffenseData, ThrowOnError>) {
        return (options.client ?? client).post<PublicOffensesControllerPayOffenseResponses, PublicOffensesControllerPayOffenseErrors, ThrowOnError>({
            url: '/api/public/offenses/pay',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Import offenses
     */
    public static importOffenses<ThrowOnError extends boolean = false>(options: Options<PublicOffensesControllerImportOffensesData, ThrowOnError>) {
        return (options.client ?? client).post<PublicOffensesControllerImportOffensesResponses, PublicOffensesControllerImportOffensesErrors, ThrowOnError>({
            url: '/api/public/offenses/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
